import React from "react";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import Footer from "../components/Footer";
import "../styles/Blog.css";

const Blog = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const blogs = t("blog.posts", { returnObjects: true }) || [];

  return (
    <div className="page-wrapper">
      <div className="page-content">
        <div className="blog-page">
          <h1 className="blog-title">{t("blog.title")}</h1>

          <div className="blog-grid">
            {blogs.map((blog) => (
              <div key={blog.id} className="blog-card">
                <img
                  src={blog.image}
                  alt={blog.title}
                  className="blog-image"
                />

                <div className="blog-content">
                  <h2>{blog.title}</h2>
                  <p>{blog.excerpt}</p>

                  <button
                    className="read-more-btn"
                    onClick={() => navigate(`/blog/${blog.id}`)}
                  >
                    {t("blog.readMore")}
                  </button>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>

      {/* ✅ Footer sits below content, outside scroll area */}
      <Footer />
    </div>
  );
};

export default Blog;